import * as api from '../displaysApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { displaysActionCreators, FetchDisplayConfigs, IDisplayConfig } from '..';
import { DisplaysActionKeys } from '../displaysActionKeys';
import { uiActionCreators } from '../../ui';

function* fetchDisplayConfigs(action: FetchDisplayConfigs) {
  yield put(uiActionCreators.toggleLoading('displayConfigs'));
  const response: IDisplayConfig[] = yield call(api.fetchDisplayConfigs);

  if (response) {
    yield put(displaysActionCreators.setDisplayConfigs(response));
  }

  yield put(uiActionCreators.toggleLoading('displayConfigs'));
}

export function* watchFetchDisplayConfigs() {
  yield takeEvery(DisplaysActionKeys.FETCH_DISPLAY_CONFIGS, fetchDisplayConfigs);
}
